export default {

    methods: {
        maxLength(value,length){
            return String(value).length >= length;
        },
        minLength(value,length){
            return String(value).length <= length;
        },
        isRequired(data) {
            return !data
        },
        isEmail(email) {
            let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (emailPattern.test(email)) {
                return false;
            } else {
                return true;
            }
        },
        isPassword(password){
            let passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/;
            return passwordPattern.test(password)
        },

        isValidPasswordPattern(password) {
            let passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]+$/;
            return passwordPattern.test(password);
        },

        isValidPasswordLength(password) {
            return password.length >= 8 && password.length <= 20;
        },

        isValidNickname(nickname) {
            let nicknamePattern = /^[가-힣a-zA-Z0-9]{2,20}$/;

            return nicknamePattern.test(nickname);
        },


        isPhone(phone) {
            let phonePattern = /^(?:(010\d{4})|(070\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;
            return phonePattern.test(phone)
        },
        isUrl(url) {
            let urlPattern = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$.*/;
            console.log(urlPattern.test(url), 'teste');
            return urlPattern.test(url)
        },

    },
}
